import { getValidationResolver, useForm } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';

export enum EditAddressField {
  street = 'street',
  street_2 = 'street_2',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
}

export interface EditAddressFormData {
  [EditAddressField.street]: string;
  [EditAddressField.street_2]: string;
  [EditAddressField.city]: string;
  [EditAddressField.state]: string;
  [EditAddressField.zipCode]: string;
}

interface Props {
  defaultValues?: Partial<EditAddressFormData>;
}

export const useEditAddressForm = ({ defaultValues }: Props = {}) => useForm<EditAddressFormData>({
  defaultValues: {
    [EditAddressField.street]: defaultValues?.street || '',
    [EditAddressField.street_2]: defaultValues?.street_2 || '',
    [EditAddressField.city]: defaultValues?.city || '',
    [EditAddressField.state]: defaultValues?.state || '',
    [EditAddressField.zipCode]: defaultValues?.zipCode || '',
  },
  resolver: getValidationResolver({
    [EditAddressField.street]: yup.string().trim().required(REQUIRED_TEXT),
    [EditAddressField.street_2]: yup.string().trim(),
    [EditAddressField.city]: yup.string().trim().required(REQUIRED_TEXT),
    [EditAddressField.state]: yup.string().required(REQUIRED_TEXT),
    [EditAddressField.zipCode]: yup.string().trim()
      .test('len', "ZIP code isn't valid", (val) => !val || val.length === 5 || val.length === 10)
      .required(REQUIRED_TEXT),
  }),
});
